import { useDispatch } from 'react-redux';

import {
	TransactionTypeAliasAuthenticationMessageOperationInputDto,
	AliasAuthenticationMessageOperationOutputDto,
} from '@api/ecommerce-xp';
import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$hooks';
import { useFetch } from '@hooks';
import { saveSuccessServiceResponse } from '@store';

export const useFetchAuthenticatorMessage = (): UseFetchHookOutput<
	Omit<TransactionTypeAliasAuthenticationMessageOperationInputDto, 'metadata'>,
	AliasAuthenticationMessageOperationOutputDto
> => {
	const dispatch = useDispatch();
	return useFetch<
		TransactionTypeAliasAuthenticationMessageOperationInputDto,
		AliasAuthenticationMessageOperationOutputDto
	>({
		operationKey: 'aliasAuthenticationMessage',
		withLoading: false,
		onSuccess: (res) => {
			if (res.data) {
				dispatch(saveSuccessServiceResponse({ aliasAuthenticationMessage: res.data }));
			}
		},
	});
};
